import {
  forceClearAllRetainedDatasets,
  forceClearRetainedDatasetsForUser,
} from "./retainedDatasetRegistry";

export const clearStudyGroupViewRestoration = (
  userId?: number | string | null,
): void => {
  if (userId == null) {
    forceClearAllRetainedDatasets();
    return;
  }
  forceClearRetainedDatasetsForUser(userId);
};
